@if (data) {
    <cerrix-workspace
        [tabID]="tabID"
        [cerrixTab]="tab"
        [data]="data"
        [headerLookup]="headerLookup"
        [module]="'control'"
        [moduleType]="moduleType"
        [idProp]="idProp"
        [permissions]="permissions"
        [filterConfig]="filterConfigs"
        [rendererConfig]="rendererConfig"
        [buttonConfig]="buttonConfig"
        [NumberProperties]="numberProps"
        [DateProperties]="dateProps"
        (onDblClick)="open($event)"
        (onAddClick)="add()"
    >
    </cerrix-workspace>
}
